import React, { Component } from 'react';
import { stateTitle, zipTitle } from '../HeaderTopContainer';

class SearchStoreLocationControls extends Component {
  render() {
    const { storesForZip, callForSearchStores, storesForState } = this.props;

    const activeStyles = {
      color: '#0F4DBC',
      borderBottom: '1px solid #0F4DBC',
    };

    const inactiveStyles = {
      color: 'initial',
      borderBottom: '1px solid #d8d8d8',
    };

    return (
      <div className="searchStoreLocationControls alignmentRow">
        <button
          className={'resetDefaultStyleBtn'}
          onClick={() => callForSearchStores(zipTitle)}
          style={storesForZip ? activeStyles : inactiveStyles}
        >
          { zipTitle }
        </button>

        <button
          className={'resetDefaultStyleBtn'}
          onClick={() => callForSearchStores(stateTitle)}
          style={storesForState ? activeStyles : inactiveStyles}
        >
          { stateTitle }
        </button>
      </div>
    );
  }
}

export default SearchStoreLocationControls;
